<template>
  <AdminModal
    :confirm-button-title="`${this.selected ? '수정' : '등록'}`"
    :modal-title="`${this.selected ? '강의 옵션 수정' : '강의 옵션 등록'}`"
    :is-open="isOpen" 
    :confirm="confirm"
    :close="close"
    modal-size="lg"
    name="lessonProductOptionModal"
  >
    <div class="py-2 px-2">
      <b-row class="my-2">
        <b-form-group label="상품명" label-cols-sm="3" label-size="sm">
          <b-form-input
            class=" mr-sm-2 md-4"
            placeholder="이름을 입력해주세요."
            v-model="title"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="상품 가격" label-cols-sm="3" label-size="sm">
          <b-form-input
            type="number"
            class=" mr-sm-2 md-4"
            placeholder="가격을 입력하세요."
            v-model="amount"
            :disabled="!!id"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2" >
        <b-form-group
          label-cols-sm="3" label-size="sm"
          label="월별 판매 제한"
          label-for="input-horizontal"
        >
          <b-form-checkbox 
            id="input-horizontal"
            v-model="setMonthlyLimitCount"
          >
            활성화
          </b-form-checkbox>
          <b-form-input
            type="number"
            class=" mr-sm-2 md-4"
            placeholder="판매 제한 갯수를 입력하세요."
            v-model="monthlyLimitCount"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="노출 여부" label-cols-sm="3" label-size="sm">
          <b-form-radio-group
            v-model="publishStatus"
            :options="publishOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          />
        </b-form-group>
      </b-row>
     
    </div>
  </AdminModal>
</template>

<script>
import api from "@/api/api";
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  name: "LessonProductOptionModal",
  components: {AdminModal},
  props: ['isOpen', 'close', 'selected', 'reload'],
  data(){
    return {
      id: null,
      title: '',
      amount: 0,
      publishStatus: "PUBLISHED",
      setMonthlyLimitCount: false,
      monthlyLimitCount: 0,
      publishOptions: [
        { item: "PUBLISHED", name: '노출' },
        { item: "UNPUBLISHED", name: '비노출' },
      ],
    }
  },
  mounted() {
    if (this.selected) {
      this.id = this.selected.id
      this.title = this.selected.title
      this.amount = this.selected.amount
      this.publishStatus = this.selected.status
      this.setMonthlyLimitCount = this.selected.setMonthlyLimitCount
      this.monthlyLimitCount = this.selected.monthlyLimitCount
    }
  },
  methods: {
    validate(){
      let errorMessage = ''
      if (this.title.length === 0){
        errorMessage = '상품명을 입력하세요.'
      }
      
      if (this.amount === 0) {
        errorMessage = '상품가격을 입력하세요.'
      }
      
      if (this.setMonthlyLimitCount) {
        if (this.monthlyLimitCount === 0) {
          errorMessage = '구매제힌 횟수를 입력하세요.'
        }
      }
      
      if (errorMessage.length > 0) {
        this.$toast.error(errorMessage,
          {
            position: "top-right",
            duration: 2000
          })
        return false
      } else {
        return true
      }
    },
    update(){
      if(this.validate()) {
        api.productLessonOption.update({
          id: this.id,
          title: this.title,
          status: this.publishStatus,
          setMonthlyLimitCount: this.setMonthlyLimitCount,
          monthlyLimitCount: this.monthlyLimitCount
        }, () => {
          this.reload()
          this.close()
        }, error => {
          alert(error.message)
        })
      }
    },
    save(){
      if(this.validate()) {
        api.productLessonOption.save({
          title: this.title,
          amount: this.amount,
          status: this.publishStatus,
          setMonthlyLimitCount: this.setMonthlyLimitCount,
          monthlyLimitCount: this.monthlyLimitCount
        }, () => {
          this.reload()
          this.close()
        }, error => {
          alert(error.message)
        })
      }
    },
    confirm() {
      if (this.id) {
        this.update()
      } else {
        this.save()
      }
    }
  },
}
</script>

<style scoped>

</style>